<app-list>  
    <app-list-item *ngFor="let node of nodes">
        <div class="text-14 text-medium mv-1" [attr.data-id]="node.id">{{ node.label }}</div>
    </app-list-item>
</app-list>
